import { Heart } from 'lucide-react';

export default function NoDepositBanner() {
  return (
    <div className="bg-[#E85D75] text-white py-2.5 px-4">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2">
        <Heart className="w-4 h-4 fill-white" />
        <span className="text-xs sm:text-sm font-medium tracking-wide">
          No Deposits Required — Pay Only When You Pick Up Your Kitten
        </span>
      </div>
    </div>
  );
}
